import React, { useEffect, useState } from "react";
import "./SidebarNav.css";

const SidebarNav = ({ sections }) => {
  const [currentSection, setCurrentSection] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setCurrentSection(sections.indexOf(entry.target.id));
          }
        });
      },
      { threshold: 0.5 }
    );

    sections.forEach((section) => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) observer.observe(sectionElement);
    });

    return () => observer.disconnect();
  }, [sections]);

  const scrollToSection = (index) => {
    const sectionElement = document.getElementById(sections[index]);

    if (index === 0) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (index === sections.length - 1) {
      window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    } else if (sectionElement) {
      const sectionTop = sectionElement.offsetTop;
      window.scrollTo({ top: sectionTop, behavior: "smooth" });
    }
  };

  return (
    <div className="sidebar-nav">
      <button
        onClick={() => scrollToSection(Math.max(currentSection - 1, 0))}
        disabled={currentSection === 0}
        className="arrow-btn"
      >
        {/* Left Arrow SVG */}
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
          <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6z" />
        </svg>
      </button>
      <div className="section-indicator">
        {currentSection + 1} / {sections.length}
      </div>
      <button
        onClick={() => scrollToSection(Math.min(currentSection + 1, sections.length - 1))}
        disabled={currentSection === sections.length - 1}
        className="arrow-btn"
      >
        {/* Right Arrow SVG */}
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
          <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z" />
        </svg>
      </button>
    </div>
  );
};

export default SidebarNav;
